import styled from 'styled-components';
import { inputStyleFactory } from 'components/Form/shared/inputStyleFactory';
import { colors } from 'assets/styled/tokens';

interface WrapperProps {
  width?: string;
  fontSize?: string;
}

interface SelectBoxProps {
  size?: 'sm' | 'md' | 'lg';
  isOpen?: boolean;
  width?: string;
  disabled?: boolean;
}

interface LeftContentProps {
  isLeftIconBlack?: boolean;
}

interface OptionProps {
  size?: 'sm' | 'md' | 'lg';
  isBold?: boolean;
  categoriasComCheckbox?: boolean;
}

interface CheckboxProps {
  isChecked?: boolean;
}

interface DropdownProps {
  isSearchable?: boolean;
  top?: string;
  showScrollbar?: boolean;
}

interface SearchWrapperProps {
  size?: 'sm' | 'md' | 'lg';
}

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  font-size: ${({ fontSize }) => fontSize};
  font-family: Roboto;
  color: ${colors.carbon};
  width: ${({ width }) => width};
`;

export const SelectBox = styled.div<SelectBoxProps>`
  border-radius: ${({ isOpen }) => (isOpen ? '4px 4px 0 0' : '4px')};
  border: 1px solid #e5e5e5;
  ${props => inputStyleFactory(props.size as any)};
  background-color: ${({ disabled }) => (disabled ? '#f5f5f5' : '#fff')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.7 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  display: flex;
  align-items: center;
  width: ${({ width }) => width};
  min-width: 0;
  max-width: ${({ width }) => width};
  justify-content: space-between;
  box-shadow: ${({ isOpen }) => (isOpen ? '0px 6px 20px 0px #0000004D' : '')};
  overflow: hidden;
  box-sizing: border-box;
`;

export const StyledPlaceholder = styled.div`
  font-weight: 400;
  color: ${colors.gray};
`;

export const StyledSelected = styled.div`
  font-weight: 700;
  color: ${colors.carbon};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  min-width: 0;
  flex: 1;
  display: block;
  max-width: 100%;
`;

export const LeftContent = styled.div<LeftContentProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
  overflow: hidden;
  > svg {
    flex-shrink: 0;
    path {
      fill: ${({ isLeftIconBlack }) => (isLeftIconBlack ? colors.carbon : '#9E9288')};
    }
  }
`;

export const RightContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  > svg {
    path {
      fill: ${({ isLeftIconBlack }) => (isLeftIconBlack ? colors.carbon : '#9E9288')};
    }
  }
`;

export const Dropdown = styled.ul.attrs<DropdownProps>(() => ({
  role: 'listbox',
}))<DropdownProps>`
  position: absolute;
  width: 100%;
  top: ${({ isSearchable, top }) => (isSearchable ? '0' : top)};
  z-index: 10;
  background-color: white;
  border: 1px solid #e5e5e5;
  max-height: 200px;
  overflow-y: auto;
  border-radius: ${({ isSearchable }) => (isSearchable ? '4px' : '0 0 4px 4px ')};
  margin-top: ${({ isSearchable }) => (isSearchable ? '0' : '4px')};
  box-shadow: 0px 6px 20px -6px #0000004d;
  ${({ showScrollbar }) =>
    !showScrollbar
      ? `
    scrollbar-width: none;
    -ms-overflow-style: none;
    ::-webkit-scrollbar {
      display: none;
    }
  `
      : `
    scrollbar-width: thin;
    scrollbar-color: ${colors.silver3} ${colors.alabaster};
    ::-webkit-scrollbar {
      width: 8px;
    }
    ::-webkit-scrollbar-track {
      background: ${colors.alabaster};
      border-radius: 4px;
    }
    ::-webkit-scrollbar-thumb {
      background: ${colors.silver3};
      border-radius: 4px;
      &:hover {
        background: ${colors.silver2 || colors.silver3};
      }
    }
  `}
`;

export const SearchWrapper = styled.div<SearchWrapperProps>`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
  position: relative;
  ${props => inputStyleFactory(props.size as any)};
  gap: 8px;
`;

export const LeftIcon = styled.div`
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none; /* ícone não bloqueia clique no input */
`;

export const RightIcon = styled.div`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-65%);
  cursor: pointer;
`;

export const SearchInput = styled.input`
  border: none;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  font-size: 14px;
  padding: 0 4px 0 14px;
  ::placeholder {
    padding: 20px;
    font-family: Roboto;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.3px;
    color: #7f746a;
  }
`;

export const IconButton = styled.div`
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  color: #888;
`;

export const Checkbox = styled.div<CheckboxProps>`
  width: 16px;
  height: 16px;
  border: 1px solid ${({ isChecked }) => (isChecked ? colors.primary : colors.lightGray)};
  border-radius: 4px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ isChecked }) => (isChecked ? colors.primary : '')};
`;

export const CheckboxIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    width: 12px;
    height: 12px;
    color: #000;
  }
`;

export const ExecPhoto = styled.img`
  border-radius: 50%;
  height: 18px;
  width: 18px;
  margin-right: 5px;
`;

export const ExecPhotoWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 50%;
  height: 18px;
  width: 18px;
  margin-right: 5px;
  overflow: hidden;
  svg {
    width: 18px;
    height: 18px;
  }
`;

export const OptionLabel = styled.span`
  flex: 1;
  min-width: 0;
  display: block;
  text-align: left;
  word-break: break-word;
  overflow-wrap: break-word;
  line-height: 1.35;
`;

export const Option = styled.li<OptionProps>`
  box-sizing: border-box;
  padding: 10px 12px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-weight: ${({ isBold }) => (isBold ? '700' : '400')};
  color: ${colors.carbon};
  ${props => inputStyleFactory(props.size as any)};
  /* inputStyleFactory aplica height fixa (ex.: 32px em md) — impede várias linhas e quebra o layout */
  height: auto !important;
  min-height: 32px;
  ${Checkbox} {
    margin-right: 0;
    flex-shrink: 0;
    margin-top: 2px;
    align-self: flex-start;
  }
  ${ExecPhoto}, ${ExecPhotoWrapper} {
    margin-right: 0;
    flex-shrink: 0;
    align-self: flex-start;
  }
  &:hover {
    background-color: ${({ categoriasComCheckbox, isBold }) => (categoriasComCheckbox ? '#eee' : isBold ? '' : '#eee')};
    cursor: ${({ categoriasComCheckbox, isBold }) =>
      categoriasComCheckbox ? 'pointer' : isBold ? 'default' : 'pointer'};
  }
`;
